<template>
  <div>
    <el-card class="box-card">
      <el-table
          :data="reader"
          border
          stripe
          style="width: 100%"
      >
        <el-table-column label="id" prop="id"></el-table-column>
        <el-table-column label="imei" prop="deviceId"></el-table-column>
        <el-table-column label="上报内容" prop="content"></el-table-column>
        <el-table-column label="上报时间" prop="create_at" width="200"></el-table-column>
      </el-table>
      <el-pagination
          :page-size="formInline.size"
          :page-sizes="[10, 20, 50]"
          :total="listCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          fixed="right"
          layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </el-card>
  </div>
</template>
<script>
import user from "../model/user";

export default {
  name: "user",
  data() {
    return {
      dialogFormVisible: false,
      formInline: {
        page: 1,
        size: 10
      },
      reader: [],
      listCount: 0
    }
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      const ret = await user.reader(this.formInline)
      if (ret.code === 200) {
        this.reader = ret.data.list;
        this.listCount = ret.data.count;
      }
    },
    handleSizeChange(val) {
      this.formInline.size = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.loadData();
    }
  }
};
</script>
<style scoped>
.demo-form-inline {
  margin-top: 20px;
}

.card-header {
  display: flex;
  align-items: center;
}

.el-pagination {
  margin: 30px 0px;
  float: right;
}
</style>
